import React from "react";
import { useInView } from "react-intersection-observer";

function SectionTitle({ index, title }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div ref={ref} className={`section-title ${inView ? "is-visible" : ""}`}>
      {index && <span className="section-index">{index}</span>}
      <h1 className="section-heading">{title}</h1>
      <span className="section-bar"></span>
    </div>
  );
}

export default SectionTitle;
